import { Component, Input } from "@angular/core";
import { DependencyTrackVulnerability } from "../../interfaces/dependency-track-vulnerability";

@Component({
  selector: "app-dependency-track-vulnerabilities-metrics",
  templateUrl: "./dependency-track-vulnerabilities-metrics.component.html",
  styleUrls: ["./dependency-track-vulnerabilities-metrics.component.css"],
})
export class DependencyTrackVulnerabilitiesMetricsComponent {
  @Input() items: DependencyTrackVulnerability;

  constructor() {}
}
